import { supabase } from '../supabase';
import { aiDisabledAwareFetch } from './aiDisabled';

/**
 * fetch per le chiamate dirette alla edge ai-chat. Prima partivano con la chiave anon: la edge
 * non vedeva l'utente, quindi l'org restava sconosciuta e l'interruttore IA dell'azienda non
 * scattava. Qui si manda il token della sessione (se c'e'), cosi' la edge ricava l'org dal
 * profilo; un 403 ai_disabled mostra il toast come per le altre edge function.
 */
export async function aiChatFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) headers.set('Authorization', `Bearer ${session.access_token}`);
  } catch {
    // senza sessione resta l'header passato dal chiamante
  }
  return aiDisabledAwareFetch(input, { ...init, headers });
}
